import { Observable } from 'rxjs';
import { CustomTriggerProvider } from '../../models/customTriggerProvider';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDao } from './BaseDao';

export class CustomTriggerProviderDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.CUSTOMTRIGGERPROVIDER, apiHelper);
  }
}
